<div>
    <vl-button @click="createNewOrganisationInvoiceGroup" :mod-disabled="disableCreate" mod-primary icon="plus" mod-icon-before>Nieuwe facturatiegroep</vl-button>
    <form class="vl-form" @submit="onSubmit">
        <vl-modal id="create-invoice-group-modal" :modLocked="false" modLarge :closable="true">
            <vl-title tag-name="h3">{{title}}</vl-title>
            <vl-u-spacer mod-medium/>
            <vl-form-grid mod-stacked>
                <vl-column width="6">
                    <kl-field-validation-wrapper-yup :field="fields.name" #default="{hasErrors}">
                        <vl-input-field name="Naam" v-model="name" :mod-error="hasErrors" mod-block/>
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="6" />
                <vl-column width="6">
                    <kl-field-validation-wrapper-yup :field="fields.email" mod-required #default="{hasErrors}">
                        <vl-input-field name="E-mail" v-model="email" :mod-error="hasErrors" mod-block/>
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="6" />
                <vl-column width="6">
                    <kl-field-validation-wrapper-yup :field="fields.attention" #default="{hasErrors}">
                        <vl-input-field name="Ter attentie van" v-model="attention" :mod-error="hasErrors" mod-block/>
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="6" />
                <vl-column width="6">
                    <kl-field-validation-wrapper-yup :field="fields.reference" #default="{hasErrors}"
                                                 annotation="Optioneel veld op uw volgende factuur. Vul bv. een interne bestelbon- of PO-nummer in.">
                        <vl-input-field name="Eigen Referentie" v-model="reference" :mod-error="hasErrors" mod-block/>
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <template v-if="showContactInfo">
                    <vl-column width="12">
                        <vl-title tag-name="h5">Contactpersoon i.v.m. facturatie</vl-title>
                        <kl-field-validation-wrapper-yup :field="fields.invoiceContactName" #default="{hasErrors}">
                            <vl-input-field name="invoice-name" v-model="invoiceContactName" :mod-error="hasErrors" mod-block />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                    <vl-column width="12">
                        <kl-field-validation-wrapper-yup :field="fields.invoiceContactEmail" #default="{hasErrors}">
                            <vl-input-field name="invoice-email" v-model="invoiceContactEmail" :mod-error="hasErrors" mod-block />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                    <vl-column width="12">
                        <kl-field-validation-wrapper-yup :field="fields.invoiceContactPhoneNumber" #default="{hasErrors}">
                            <vl-input-field name="invoice-phone" placeholder="+32" v-model="invoiceContactPhoneNumber" :mod-error="hasErrors" mod-block />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </template>
                <vl-column width="12" />
                <vl-column width="12">
                    <vl-form-message-label>Selecteer de organisaties</vl-form-message-label>
                    <vl-form-message-annotation>
                        Let op! Aanpassingen aan organisaties worden toegepast op nieuwe planaanvragen. U ontvangt deze maand mogelijks nog meerdere facturen.
                    </vl-form-message-annotation>
                </vl-column>
                <vl-column width="12">
                    <ippro-datatable id="organisations" :meta="organisationsMeta" :fetching="isOrganisationsDataTableLoading" :dataset="allOrganisations" :columns="organisationsColumns"
                                     @checkbox-change="checkboxChanged"
                                     mod-hide-header mod-checkable-rows mod-zebra mod-hide-pagination>
                    </ippro-datatable>
                </vl-column>
            </vl-form-grid>

            <template v-slot:modal-footer>
                <vl-action-group>
                    <vl-button type="submit" mod-large :mod-disabled="disableSubmit" :mod-loading="isSending">
                        {{submitButtonLabel}}
                    </vl-button>
                    <vl-button type="button" mod-link @click="cancel" icon="cross" mod-icon-before>
                        Annuleer
                    </vl-button>
                </vl-action-group>
            </template>
        </vl-modal>
    </form>
</div>
